import { getSuperTokensApiService } from '../services/superTokensApiService'

export async function getDBJWT(): Promise<string> {
  const service = getSuperTokensApiService()
  return await service.getPublicDBJWT()
}

export function getApiService() {
  return getSuperTokensApiService()
}
